module.exports = __webpack_public_path__ + "static/media/BA.f27ae1ea.svg";